import { createArrayIntentType } from '../intent';
export const lazyTokenIntent = createArrayIntentType('LazyTokenIntent', (decorate)=>(overrides)=>decorate(overrides));
export const lazyGlobalTokenIntent = createArrayIntentType('LazyGlobalTokenIntent', (decorate)=>(overrides)=>decorate(overrides));

//# sourceMappingURL=intents.js.map